<template>
  <div class="sel-modal clearfix">
    <div class="sel-modal-header clearfix">
      <vxe-radio-group v-model="selectTab">
        <ul class="tab-list">
          <li>
            <vxe-radio name="xtabs" label="tab1">平台审核</vxe-radio>
          </li>
          <li>
            <vxe-radio name="xtabs" label="tab2">税务机关审核</vxe-radio>
          </li>
        </ul>
      </vxe-radio-group>
    </div>
    <div v-show="selectTab === 'tab1'">
      <div class="audi-box" v-if="audiList && audiList.auditUser">
        <div class="audi-top">
          <Icon
              type="ios-calendar"
              size="20"
              color="#FB9D5C"
              style="margin-right: 5px; margin-top: -5px; vertical-align: middle"
          />
          审核记录
        </div>
        <div class="audi-mid">
          审核人员：{{ audiList.auditUser }} <i>|</i> 审核时间：
          {{ audiList.auditTime | timeFormatDate }}
        </div>
        <div class="audi-btm">
          {{ audiList.auditInfo }}
        </div>
      </div>
      <div class="audi-box" v-if="audiList && audiList.reAuditUser">
        <div class="audi-top">
          <Icon
              type="ios-calendar"
              size="20"
              color="#FB9D5C"
              style="margin-right: 5px; margin-top: -5px; vertical-align: middle"
          />
          复核记录
        </div>
        <div class="audi-mid">
          复核人员：{{ audiList.reAuditUser }} <i>|</i> 复核时间：
          {{ audiList.reAuditTime | timeFormatDate }}
        </div>
        <div class="audi-btm">
          {{ audiList.reAuditInfo }}
        </div>
      </div>
      <div class="no-audi-box" v-if="audiList && !audiList.auditUser && !audiList.reAuditUser">
        <div class="no-audi-box-bg"></div>
        <div>无审核记录</div>
      </div>
    </div>
    <div v-show="selectTab === 'tab2'">
      <div class="audi-box" v-for="(item,index) in taxList" :key="index">
        <div class="audi-top">
          <Icon
              type="ios-calendar"
              size="20"
              color="#FB9D5C"
              style="margin-right: 5px; margin-top: -5px; vertical-align: middle"
          />
          税务机关审核记录
        </div>
        <div class="audi-mid">
          税务机关：{{ item.taxComp }} | 审核人员：{{ item.taxUserCheck }} | 审核时间：
          {{ item.checkTime | timeFormat }}
        </div>
        <div class="audi-btm">
          {{ item.taxState >= 4 ? '审核通过' : item.note }}
        </div>
      </div>
      <div class="no-audi-box" v-if="taxList.length === 0">
        <div class="no-audi-box-bg"></div>
        <div>无审核记录</div>
      </div>
    </div>
  </div>
</template>

<script>
import $api from '@/apiProvider'
import {hideLoading, showLoading} from "@/utils/util";

export default {
  props: {
    isTax: {
      type: Boolean,
      default: false
    },
    isMatching: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      selectTab: "tab1",
      audiList: [],
      taxList: [],
    };
  },
  created() {

  },
  methods: {
    init(id) {
      this.getMatchingOrderDetail(id);
      this.getOrderDetail(id);
      if (this.isMatching) {
        this.auditInfoMatch(id);
      } else {
        this.showAudiList(id);
      }
    },
    async showAudiList(id) {
      let res = await $api.twoOrders.post("auditInfo", {id: id});
      if (res.status === 1) {
        this.audiList = res.data;
      }
    },
    async auditInfoMatch(id) {
      let res = await $api.matchOrder.post("auditInfoMatch", {id: id});
      if (res.status === 1) {
        this.audiList = res.data;
      }
    },
    async getMatchingOrderDetail(id) {
      showLoading();
      let res = await $api.matchOrder.post("detail", {id});
      hideLoading();
      if (res.status === 1) {
        this.taxList = [];
        res.data.taxList.map(i => {
          if (i.taxState > 2) {
            this.taxList.push(i)
          }
        })
      }
    },
    async getOrderDetail(id) {
      showLoading();
      let res = await $api.twoOrders.post("detail", {id});
      hideLoading();
      if (res.status === 1) {
        this.taxList = [];
        res.data.taxList.map(i => {
          if (i.taxState > 2) {
            this.taxList.push(i)
          }
        })
      }
    }
  },
};
</script>

<style lang="less">
.no-audi-box {
  display: flex;
  width: 100%;
  height: 500px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.no-audi-box-bg {
  background: url("~assets/images/common/noPayRecord.png") no-repeat;
  background-size: 300px auto;
  width: 300px;
  height: 200px;
}

.audi-box {
  background-color: #f9f9f9;
  padding: 10px;
  margin-bottom: 10px;

  .audi-top {
    padding: 10px 0;
    width: 100%;
    border-bottom: 1px solid #e3e3e3;
    color: #383838;
  }

  .audi-mid {
    padding: 10px 5px;
    width: 100%;
    box-sizing: border-box;
    font-size: 13px;

    i {
      padding: 0 5px;
    }
  }

  .audi-btm {
    padding: 10px;
    width: 100%;
    box-sizing: border-box;
    background-color: #eaf4fe;
  }
}
</style>